import { useTranslation } from 'react-i18next';
import { BigLink } from '@/components/BigLink';
import { ClipImage } from '@/components/ClipImage';
import { Meta } from '@/components/Meta';
import { Reveal } from '@/components/Reveal';
import { recognitions, studio } from '@/data/studio';
import { useLang } from '@/hooks/useLang';

export function StudioPage() {
  const { t } = useTranslation();
  const lang = useLang();

  return (
    <>
      <Meta title={t('meta.studioTitle')} description={t('meta.studioDesc')} />

      <header className="u-container grid items-end gap-10 pt-[22vh] pb-16 md:grid-cols-12">
        <div className="md:col-span-7">
          <p className="eyebrow text-stone">{t('studio.eyebrow')}</p>
          <h1 className="mt-5 font-display text-6xl md:text-8xl">{t('studio.title')}</h1>
        </div>
        <div className="md:col-span-4 md:col-start-9">
          <ClipImage src={studio.portrait} alt={studio.name} className="aspect-3/4 w-full" />
        </div>
      </header>

      <section className="u-container grid gap-10 pb-[10vh] md:grid-cols-2">
        <Reveal>
          <p className="font-display text-2xl leading-snug md:text-3xl">{t('studio.bio1')}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="leading-relaxed text-ink-soft">{t('studio.bio2')}</p>
        </Reveal>
      </section>

      <div className="u-container py-[6vh]">
        <div className="relative mx-auto flex h-[60vh] w-full items-center justify-center overflow-hidden bg-paper-deep md:h-[80vh]">
          <img
            src={studio.atelier}
            alt={`${studio.name} nel suo atelier`}
            loading="lazy"
            decoding="async"
            className="max-h-full max-w-full object-contain"
          />
        </div>
      </div>


      <section className="u-container py-[12vh]">
        <p className="eyebrow mb-10 text-stone">{t('studio.recognitions')}</p>
        <ul className="divide-y divide-line">
          {recognitions.map((r) => {
            const title = lang === 'en' && r.titleEn ? r.titleEn : r.title;
            const detail = lang === 'en' && r.detailEn ? r.detailEn : r.detail;
            return (
              <li key={`${r.title}-${r.year}`} className="grid gap-3 py-7 md:grid-cols-12 md:items-baseline">
                <span className="eyebrow text-stone md:col-span-2">{r.year}</span>
                <span className="font-display text-2xl md:col-span-4">{title}</span>
                <span className="leading-relaxed text-ink-soft md:col-span-6">{detail}</span>
              </li>
            );
          })}
        </ul>
      </section>

      <section className="u-container pb-[16vh] text-center">
        <BigLink to="/contatti" className="text-[15vw] hover:opacity-70 md:text-[9.5vw]">
          {t('studio.contactCta')}
        </BigLink>
      </section>
    </>
  );
}
